import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    margin: {
      marginTop: 20,
      marginBottom: 20,
    },
    emptyMessage: {
      paddingTop: 20,
      paddingBottom: 20,
      fontStyle: 'italic',
    },
    table: {
      borderCollapse: 'separate',
      borderSpacing: '0px 4px',

      '& .MuiTableCell-body': {
        color: variables.richBlack,
      },
    },
    button: {
      marginInlineStart: 10,
      fontSize: 16,
      fontWeight: 600,
      color: variables.richBlack,

      '&:hover': {
        backgroundColor: variables.white,
        color: variables.black50,
      },
    },
  }),
);
